import { ChangeDetectorRef, Component, Inject, OnDestroy } from "@angular/core";
import { MatCalendar } from "@angular/material/datepicker";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
    selector: 'datepicker-custom-header',
    styles: [
        `
            .custom-date-header {
              display: flex;
              align-items: center;
              justify-content: space-around;
              padding: 0.5em;
            }
        `,
    ],
    template: require('./date-picker-custom-header.component.html')
})
export class DatePickerCustomHeaderComponent<D> implements OnDestroy{
    private _destroyed = new Subject<void>();

    constructor(
        @Inject(MatCalendar<D>) private _calendar: MatCalendar<D>,
        @Inject(DateAdapter<D>) private _dateAdapter: DateAdapter<D>,
        @Inject(MAT_DATE_FORMATS) private _dateFormats: any,
        @Inject(ChangeDetectorRef) cdr: ChangeDetectorRef,
    ) {
        _calendar.stateChanges.pipe(takeUntil(this._destroyed)).subscribe(() => cdr.markForCheck());
    }

    ngOnDestroy() {
        this._destroyed.next();
        this._destroyed.complete();
    }

    get periodLabel() {
        return this._dateAdapter.format(this._calendar.activeDate, this._dateFormats.display.headerDisplay);
    }

    previousClicked() {
        this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1);
    }

    nextClicked() {
        this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1)
    }
}
